import React, { Component } from "react";

import './style.css';
import LogoItem from '../logo';
import {ToastContainer, ToastStore} from 'react-toasts';


class Logos extends Component {
    render(){
        return(
            <div className="reports-main-content">
                <h3 className="orange-title-left">Manage Logos for All Devices</h3>
                <hr className="line"/>

                <div className="logo-grid">
                    <div className="logo-row">
                        <LogoItem title='Site Logo' type='site_logo' notification={ToastStore} />
                        <LogoItem title='Report Logo' type='report_logo' notification={ToastStore} />
                    </div>
                    <div className="logo-row">
                        <LogoItem title='Report Footer Logo (LEFT)' type='left_footer_logo' notification={ToastStore} />
                        <LogoItem title='Report Footer Logo (RIGHT)' type='right_footer_logo' notification={ToastStore} />
                    </div>
                </div>
                <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
            </div>
        )
    }
}

export default Logos;